import React from 'react';
import SupportArticlesItem from './SupportArticlesItem';
import { Box, Grid, Typography } from '@mui/material';
import { LaptopIcon, PhoneAndroidOutlinedIcon, ShoppingCartOutlinedIcon } from 'icons/materialIcons';
import articlesData from './supportArticles.json'; // Adjust the path as necessary

const iconMap = {
  LaptopIcon: <LaptopIcon fontSize="small" />,
  PhoneAndroidOutlinedIcon: <PhoneAndroidOutlinedIcon fontSize="small" />,
  ShoppingCartOutlinedIcon: <ShoppingCartOutlinedIcon fontSize="small" />,
};

const SupportArticles = () => {
  return (
    <Box sx={{ padding: 2 }}>
      <Typography variant="h5" sx={{ fontWeight: 500, fontSize: '1.4rem', marginBottom: "12px" }} gutterBottom>
        Support Articles
      </Typography>
      <Typography variant="body1" sx={{ marginBottom: 1, color: '#828282', fontSize: '0.9rem' }}>
        Browse our library of over 100 support articles to help you get the most out of Touch features
      </Typography>
      <Grid container spacing={2}>
        {articlesData.map((article, index) => (
          <Grid item xs={12} sm={4} key={index}>
            <SupportArticlesItem
              title={article.title}
              description={article.description}
              articleId={article.id} // Pass the index or a unique ID
            >
              {iconMap[article.icon]}
            </SupportArticlesItem>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SupportArticles;
